export default __webpack_public_path__ + "static/media/blueCheck.0a4577b3.png";